import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={26}
      height={26}
      rx={6.11765}
      fill="url(#paint0_linear_15401_16345)"
    />
    <path
      d="M4.58789 8.05901C4.58789 6.98684 5.45706 6.11768 6.52922 6.11768H19.8071C20.8793 6.11768 21.7484 6.98684 21.7484 8.05901V16.6919C21.7484 17.7641 20.8793 18.6333 19.8071 18.6333H6.52922C5.45706 18.6333 4.58789 17.7641 4.58789 16.6919V8.05901Z"
      fill="url(#paint1_linear_15401_16345)"
    />
    <path
      d="M4.4033 5.56884C4.50315 5.1284 4.94115 4.85229 5.38159 4.95214L22.7408 8.88754C23.1813 8.98739 23.4574 9.42538 23.3575 9.86582L22.7973 12.3368C22.7542 12.527 22.5594 12.6685 22.3085 12.7812C22.0009 12.9194 21.7592 13.1958 21.6788 13.5504L20.921 16.8929C20.8406 17.2476 20.9396 17.6011 21.1575 17.8584C21.3352 18.0684 21.45 18.2801 21.4069 18.4702L20.8467 20.9413C20.7468 21.3817 20.3088 21.6578 19.8684 21.5579L2.50917 17.6226C2.06873 17.5227 1.79262 17.0847 1.89247 16.6443L2.43422 14.2546C2.45763 14.1513 2.52489 14.0618 2.6297 13.9819C2.73525 13.9015 2.86952 13.8382 3.00679 13.7872C3.34663 13.6608 3.61862 13.3705 3.7049 12.9899L4.46265 9.64745C4.54894 9.26683 4.42872 8.88763 4.1766 8.62708C4.07476 8.52184 3.98091 8.40684 3.92037 8.28875C3.86025 8.17148 3.83816 8.06174 3.86157 7.95846L4.4033 5.56884Z"
      fill="url(#paint2_linear_15401_16345)"
    />
    <path
      d="M4.4033 5.56884C4.50315 5.1284 4.94115 4.85229 5.38159 4.95214L22.7408 8.88754C23.1813 8.98739 23.4574 9.42538 23.3575 9.86582L22.7973 12.3368C22.7542 12.527 22.5594 12.6685 22.3085 12.7812C22.0009 12.9194 21.7592 13.1958 21.6788 13.5504L20.921 16.8929C20.8406 17.2476 20.9396 17.6011 21.1575 17.8584C21.3352 18.0684 21.45 18.2801 21.4069 18.4702L20.8467 20.9413C20.7468 21.3817 20.3088 21.6578 19.8684 21.5579L2.50917 17.6226C2.06873 17.5227 1.79262 17.0847 1.89247 16.6443L2.43422 14.2546C2.45763 14.1513 2.52489 14.0618 2.6297 13.9819C2.73525 13.9015 2.86952 13.8382 3.00679 13.7872C3.34663 13.6608 3.61862 13.3705 3.7049 12.9899L4.46265 9.64745C4.54894 9.26683 4.42872 8.88763 4.1766 8.62708C4.07476 8.52184 3.98091 8.40684 3.92037 8.28875C3.86025 8.17148 3.83816 8.06174 3.86157 7.95846L4.4033 5.56884Z"
      fill="url(#paint3_linear_15401_16345)"
    />
    <path
      d="M4.4033 5.56884C4.50315 5.1284 4.94115 4.85229 5.38159 4.95214L22.7408 8.88754C23.1813 8.98739 23.4574 9.42538 23.3575 9.86582L22.7973 12.3368C22.7542 12.527 22.5594 12.6685 22.3085 12.7812C22.0009 12.9194 21.7592 13.1958 21.6788 13.5504L20.921 16.8929C20.8406 17.2476 20.9396 17.6011 21.1575 17.8584C21.3352 18.0684 21.45 18.2801 21.4069 18.4702L20.8467 20.9413C20.7468 21.3817 20.3088 21.6578 19.8684 21.5579L2.50917 17.6226C2.06873 17.5227 1.79262 17.0847 1.89247 16.6443L2.43422 14.2546C2.45763 14.1513 2.52489 14.0618 2.6297 13.9819C2.73525 13.9015 2.86952 13.8382 3.00679 13.7872C3.34663 13.6608 3.61862 13.3705 3.7049 12.9899L4.46265 9.64745C4.54894 9.26683 4.42872 8.88763 4.1766 8.62708C4.07476 8.52184 3.98091 8.40684 3.92037 8.28875C3.86025 8.17148 3.83816 8.06174 3.86157 7.95846L4.4033 5.56884Z"
      stroke="url(#paint4_linear_15401_16345)"
      strokeWidth={0.305882}
    />
    <path
      d="M13.25 9.25108C13.3466 9.16668 13.4452 9.07707 13.5464 8.98499C13.582 8.95263 13.618 8.91997 13.6542 8.88712L13.7365 8.81271L13.6377 8.76231L12.7097 8.28876L12.6637 8.26525L12.6247 8.29924C11.5318 9.25254 10.3763 9.91021 9.16075 10.2653L9.07404 10.2906L9.11334 10.3719L9.55241 11.2808L9.58222 11.3425L9.64683 11.3196C9.71055 11.297 9.77298 11.2736 9.83529 11.2503C9.89579 11.2277 9.95616 11.2051 10.0175 11.1833L9.42718 13.5229L9.40848 13.5971L9.48262 13.6158L11.5695 14.1423C11.5494 14.167 11.5283 14.1927 11.5053 14.2195C10.8206 14.9297 9.6174 15.3951 7.8603 15.5875L7.75336 15.5992L7.79956 15.6964L8.23627 16.6146L8.25995 16.6644L8.31469 16.6576C10.3404 16.4077 11.7457 15.7943 12.5123 14.8223L12.5127 14.8218L12.5134 14.8208C12.6059 14.7016 12.6999 14.5803 12.7891 14.45L12.9255 14.4844L12.4828 16.2391C12.3847 16.628 12.391 16.9559 12.521 17.2121C12.6523 17.4708 12.9013 17.6406 13.2531 17.7294L15.1288 18.2027C15.4771 18.2905 15.776 18.2734 16.0028 18.1291L16.0028 18.1291L16.0043 18.1281C16.1307 18.0433 16.2582 17.8571 16.3906 17.5896C16.525 17.3181 16.6707 16.9495 16.8282 16.4838L16.8478 16.4261L16.7958 16.3942L15.9406 15.8692L15.8547 15.8164L15.8271 15.9134C15.74 16.2193 15.6615 16.4616 15.5943 16.64C15.5264 16.8207 15.4731 16.9271 15.4384 16.9707C15.3669 17.0532 15.2939 17.079 15.2176 17.0598L13.8296 16.7096C13.7334 16.6853 13.6829 16.6415 13.6581 16.5864C13.6315 16.5274 13.6273 16.44 13.6585 16.3163L14.0492 14.7679L16.0946 15.284L16.1688 15.3027L16.1875 15.2286L16.966 12.143L16.9847 12.0688L16.9106 12.0501L15.0058 11.5695C15.3364 11.3661 15.6808 11.134 16.0359 10.8597L16.0569 10.8435L16.0633 10.8179L16.2479 10.0863L16.2666 10.0122L16.1925 9.99349L13.25 9.25108ZM13.5713 11.2076L11.2583 10.624C11.5628 10.4575 11.8701 10.2768 12.1763 10.0756L14.497 10.6612C14.1781 10.8665 13.872 11.0472 13.5713 11.2076ZM13.7695 12.383L15.6222 12.8504L15.3426 13.9589L13.3582 13.4582C13.5098 13.125 13.6502 12.7718 13.7695 12.383ZM11.0624 11.7L12.6347 12.0967C12.5073 12.4845 12.3636 12.8436 12.2055 13.1674L10.7827 12.8084L11.0624 11.7Z"
      fill="url(#paint5_linear_15401_16345)"
      stroke="white"
      strokeWidth={0.152941}
    />
    <defs>
      <linearGradient
        id="paint0_linear_15401_16345"
        x1={31.5}
        y1={33.5}
        x2={-0.500001}
        y2={-2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1C77FF" />
        <stop offset={1} stopColor="#44C7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15401_16345"
        x1={13.1682}
        y1={6.11768}
        x2={13.1682}
        y2={18.6333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6AC9FF" />
        <stop offset={1} stopColor="#73E2F1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_15401_16345"
        x1={9.59286}
        y1={4.58838}
        x2={19.915}
        y2={19.0394}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFEFD" stopOpacity={0.42} />
        <stop offset={1} stopColor="#FFFEFD" stopOpacity={0.78} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_15401_16345"
        x1={14.095}
        y1={6.77068}
        x2={11.155}
        y2={19.7394}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFEFD" stopOpacity={0} />
        <stop offset={1} stopColor="#FFFEFD" stopOpacity={0.78} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_15401_16345"
        x1={3.82353}
        y1={4.58838}
        x2={20.6471}
        y2={22.9413}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.56} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_15401_16345"
        x1={10.7055}
        y1={9.52927}
        x2={15.9049}
        y2={19.558}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3FBDFF" />
        <stop offset={1} stopColor="#288EFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
